var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 745,
    height: 594,
    viewBox: "0 0 745 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.323 536.899C254.633 612.81 490.243 612.81 635.553 536.899C780.864 460.987 780.864 337.907 635.553 261.979C490.243 186.05 254.699 186.067 109.323 261.979C-36.0542 337.89 -35.9213 460.987 109.323 536.899Z",
    fill: "#303940"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.817 412.406L21.582 385.142V283.827L68.817 311.108V412.406Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8174 311.108L136.305 272.147V373.446L68.8174 412.407V311.108Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.305 272.147L68.817 311.108L21.582 283.827L89.0701 244.866L136.305 272.147Z",
    fill: "#37474F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5791 314.996L129.56 283.827L130.806 284.541V322.073L76.8086 353.242L75.5625 352.528L75.5791 314.996Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8086 315.727L130.806 284.541V322.073L76.8086 353.242V315.727Z",
    fill: "#37474F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9753 309.862L107.163 304.562C108.343 303.864 109.306 304.18 109.306 305.26C109.221 305.921 108.983 306.554 108.611 307.107C108.239 307.661 107.743 308.12 107.163 308.45L97.9753 313.75C96.7791 314.447 95.8154 314.132 95.8154 313.052C95.9016 312.388 96.1418 311.754 96.5168 311.2C96.8919 310.647 97.3913 310.188 97.9753 309.862Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.333 362.48L128.313 331.311V368.843L129.56 369.558L75.5625 400.727L74.333 400.012V362.48Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 363.194L129.56 332.026V369.558L75.5625 400.726V363.194Z",
    fill: "#37474F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7292 357.346L106 352.062C107.196 351.365 108.16 351.68 108.16 352.76C108.074 353.424 107.834 354.058 107.459 354.611C107.083 355.165 106.584 355.624 106 355.95L96.8122 361.25C95.616 361.948 94.6523 361.632 94.6523 360.552C94.727 359.894 94.9534 359.261 95.3138 358.705C95.6741 358.149 96.1586 357.683 96.7292 357.346Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.817 311.26L21.582 283.979V182.68L68.817 209.944V311.26Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8174 209.944L136.305 170.983V272.298L68.8174 311.259V209.944Z",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.305 170.983L68.817 209.944L21.582 182.68L89.0701 143.719L136.305 170.983Z",
    fill: "#37474F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 207.849L129.56 176.68L130.806 177.394V214.927L76.8086 246.095L75.5625 245.364V207.849Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9753 202.698L107.147 197.398C108.343 196.717 109.306 197.033 109.306 198.113C109.218 198.775 108.977 199.408 108.602 199.962C108.227 200.515 107.729 200.974 107.147 201.303L97.9753 206.603C96.7791 207.284 95.8154 206.985 95.8154 205.905C95.9029 205.24 96.1434 204.604 96.5182 204.047C96.893 203.491 97.3918 203.029 97.9753 202.698Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.333 261.333L128.313 230.164V267.68L129.56 268.394L75.5625 299.563L74.333 298.848V261.333Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 262.047L129.56 230.879V268.394L75.5625 299.563V262.047Z",
    fill: "#37474F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7292 250.182L106 244.882C107.18 244.201 108.16 244.517 108.16 245.597C108.066 246.258 107.823 246.889 107.449 247.442C107.075 247.994 106.579 248.454 106 248.787L96.7292 254.037C95.533 254.718 94.5693 254.402 94.5693 253.339C94.664 252.683 94.908 252.057 95.2824 251.51C95.6569 250.962 96.1518 250.508 96.7292 250.182Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5625 213.849L129.56 182.68V220.196L75.5625 251.364V213.849Z",
    fill: "#1F2D34"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.558 195.222L127.001 178.159V211.222L156.558 228.268V195.222Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8154 256.714V209.944L107.396 203.232L109.306 206.057L143.05 186.568V229.433L95.8154 256.714Z",
    fill: "#182830"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8154 256.714L99.1882 215.793L146.423 188.528L143.05 229.433L95.8154 256.714Z",
    fill: "#37474F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.561 232.39L76.8086 217.521V250.583L102.561 265.437V232.39Z",
    fill: "#182830"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.562 229.433L156.559 198.264V235.78L102.562 266.949V229.433Z",
    fill: "#37474F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.728 223.568L132.899 218.268C134.096 217.587 135.059 217.903 135.059 218.983C134.969 219.645 134.728 220.277 134.353 220.831C133.978 221.384 133.481 221.843 132.899 222.173L123.728 227.473C122.532 228.154 121.568 227.838 121.568 226.775C121.656 226.11 121.896 225.474 122.271 224.917C122.646 224.361 123.145 223.899 123.728 223.568Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M102.561 229.433L100.767 228.403V265.919L102.561 266.949V229.433Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.767 228.403L154.747 197.218L156.558 198.264L102.561 229.433L100.767 228.403Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M626.865 351.032L579.613 323.751V222.453L626.865 249.717V351.032Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M626.864 249.717L694.352 210.756V312.072L626.864 351.033V249.717Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M694.353 210.756L626.865 249.717L579.613 222.453L647.118 183.475L694.353 210.756Z",
    fill: "#37474F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M633.61 253.622L687.607 222.453L688.854 223.167L688.837 260.683L634.856 291.852L633.61 291.137V253.622Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M634.856 254.336L688.854 223.167L688.837 260.683L634.856 291.852V254.336Z",
    fill: "#37474F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M656.023 248.471L665.194 243.171C666.391 242.49 667.354 242.806 667.354 243.869C667.267 244.534 667.026 245.17 666.651 245.726C666.277 246.283 665.778 246.745 665.194 247.076L656.023 252.376C654.827 253.057 653.863 252.741 653.863 251.678C653.951 251.013 654.191 250.377 654.566 249.821C654.941 249.264 655.44 248.802 656.023 248.471Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M632.364 301.106L686.361 269.921V307.453L687.607 308.167L633.61 339.336L632.364 338.621V301.106Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M633.61 301.82L687.607 270.652V308.167L633.61 339.336V301.82Z",
    fill: "#37474F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M654.777 295.955L663.965 290.655C665.144 289.974 666.108 290.29 666.108 291.353C666.02 292.016 665.781 292.65 665.409 293.206C665.038 293.762 664.544 294.225 663.965 294.56L654.777 299.86C653.581 300.541 652.617 300.225 652.617 299.145C652.707 298.483 652.949 297.851 653.323 297.297C653.698 296.744 654.196 296.285 654.777 295.955Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M177.441 456.917C177.441 456.917 177.624 430.566 161.01 410.811C146.306 393.316 138.48 382.218 143.116 377.101C147.751 371.983 157.72 370.754 171.161 384.909C184.602 399.065 185.649 438.275 183.788 447.147L177.441 456.917Z",
    fill: "url(#paint0_linear_2092_26474)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.441 456.917C177.441 456.917 177.624 430.566 161.01 410.811C146.306 393.316 138.48 382.218 143.116 377.101C147.751 371.983 157.72 370.754 171.161 384.909C184.602 399.065 185.649 438.275 183.788 447.147L177.441 456.917Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M180.234 428.589C180.045 428.59 179.861 428.526 179.713 428.408C179.565 428.29 179.461 428.126 179.42 427.941C173.605 400.743 158.685 385.707 150.294 379.161C150.121 379.026 150.007 378.828 149.979 378.61C149.951 378.392 150.011 378.172 150.145 377.998C150.283 377.823 150.483 377.709 150.704 377.681C150.925 377.653 151.148 377.713 151.325 377.848C159.881 384.494 175.116 399.879 181.048 427.592C181.072 427.698 181.075 427.808 181.056 427.915C181.038 428.022 180.998 428.124 180.939 428.215C180.88 428.307 180.804 428.385 180.714 428.447C180.624 428.508 180.523 428.551 180.416 428.572L180.234 428.589Z",
    fill: "#37474F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M176.81 466.703L170.048 470.607C169.327 468.636 168.111 466.884 166.516 465.519C164.921 464.154 163.002 463.223 160.944 462.815C153.55 461.153 145.874 461.436 140.691 455.023C135.507 448.609 141.82 441.631 140.691 436.913C139.561 432.194 138.83 430.832 129.559 426.113C120.288 421.395 116.633 413.569 123.611 408.269C130.589 402.969 141.887 406.857 148.732 411.592C154.813 415.746 160.595 416.842 167.39 417.69C174.185 418.537 185.251 422.309 183.556 438.092C182.446 447.862 180.182 457.466 176.81 466.703Z",
    fill: "url(#paint1_linear_2092_26474)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M150.859 445.968C150.682 445.966 150.51 445.909 150.367 445.805C150.224 445.701 150.117 445.554 150.062 445.386C149.999 445.175 150.021 444.947 150.123 444.752C150.226 444.556 150.4 444.408 150.61 444.34C151.208 444.157 165.563 439.604 171.66 444.489C171.812 444.632 171.904 444.826 171.919 445.034C171.934 445.242 171.87 445.447 171.74 445.61C171.611 445.773 171.425 445.881 171.219 445.914C171.014 445.946 170.804 445.9 170.63 445.785C165.247 441.465 151.258 445.885 151.108 445.935L150.859 445.968Z",
    fill: "#37474F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M177.558 465.44C177.356 465.441 177.16 465.367 177.01 465.231C176.859 465.096 176.764 464.91 176.744 464.709C173.039 429.719 130.888 413.121 130.472 412.955C130.369 412.916 130.275 412.857 130.195 412.782C130.115 412.706 130.05 412.616 130.006 412.515C129.961 412.415 129.936 412.306 129.934 412.196C129.931 412.086 129.951 411.977 129.991 411.875C130.072 411.673 130.228 411.511 130.426 411.421C130.624 411.332 130.849 411.321 131.054 411.393C131.502 411.576 174.584 428.522 178.389 464.559C178.412 464.777 178.348 464.995 178.211 465.167C178.074 465.338 177.875 465.448 177.657 465.473L177.558 465.44Z",
    fill: "#37474F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M590.811 443.725C590.993 443.143 598.121 406.458 590.811 380.44C584.165 356.582 575.492 347.776 563.131 345.832C550.77 343.888 545.403 352.794 551.966 364.856C558.529 376.918 574.329 392.918 578.2 419.866C579.862 430.965 581.124 440.601 581.124 440.601L590.811 443.725Z",
    fill: "url(#paint2_linear_2092_26474)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M590.811 443.725C590.993 443.143 598.121 406.458 590.811 380.44C584.165 356.582 575.492 347.776 563.131 345.832C550.77 343.888 545.403 352.794 551.966 364.856C558.529 376.918 574.329 392.918 578.2 419.866C579.862 430.965 581.124 440.601 581.124 440.601L590.811 443.725Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M586.64 422.658C586.531 422.651 586.424 422.623 586.325 422.576C586.227 422.528 586.139 422.461 586.066 422.379C585.994 422.298 585.938 422.202 585.903 422.099C585.867 421.996 585.852 421.886 585.859 421.777C587.52 392.07 577.818 365.554 560.422 352.544C560.246 352.412 560.129 352.215 560.098 351.997C560.067 351.779 560.124 351.558 560.256 351.381C560.391 351.209 560.587 351.095 560.804 351.064C561.021 351.033 561.241 351.087 561.419 351.215C579.246 364.507 589.248 391.622 587.504 421.877C587.491 422.094 587.393 422.298 587.232 422.444C587.07 422.59 586.857 422.667 586.64 422.658Z",
    fill: "#37474F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M609.934 462.832C608.987 456.003 612.908 445.768 622.229 443.343C631.55 440.917 635.703 435.567 632.347 429.719C628.991 423.871 629.772 418.504 638.229 416.078C646.685 413.653 654.095 409.433 649.227 400.494C645.689 394.031 644.908 389.844 653.58 377.117C660.774 366.551 654.893 360.353 645.888 361.516C636.883 362.679 631.317 373.412 625.685 375.207C620.052 377.001 618.756 367.431 611.33 371.718C603.903 376.004 604.352 386.986 604.119 394.646C603.886 402.305 603.388 404.033 596.676 403.102C589.964 402.172 583.384 403.269 583.534 419.501C583.65 433.424 591.077 450.67 591.077 450.67L609.934 462.832Z",
    fill: "url(#paint3_linear_2092_26474)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M598.154 452.447H598.071C597.849 452.422 597.645 452.31 597.505 452.136C597.365 451.962 597.3 451.739 597.323 451.517C602.008 409.665 637.929 374.359 647.299 367.198C647.476 367.064 647.698 367.005 647.918 367.035C648.137 367.064 648.336 367.18 648.471 367.356C648.605 367.532 648.664 367.755 648.634 367.974C648.605 368.194 648.489 368.393 648.313 368.527C639.059 375.589 603.603 410.429 598.984 451.7C598.96 451.904 598.863 452.092 598.71 452.23C598.557 452.367 598.359 452.445 598.154 452.447Z",
    fill: "#37474F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M614.537 407.704C614.368 407.703 614.204 407.652 614.065 407.558C613.926 407.463 613.818 407.329 613.756 407.173C613.685 406.963 613.697 406.734 613.789 406.533C613.882 406.332 614.049 406.175 614.254 406.093C627.645 401.108 642.831 403.468 643.479 403.567C643.694 403.604 643.886 403.724 644.014 403.901C644.141 404.078 644.194 404.299 644.16 404.514C644.12 404.729 643.999 404.92 643.824 405.049C643.648 405.179 643.43 405.237 643.213 405.212C643.064 405.212 627.812 402.82 614.836 407.655C614.739 407.687 614.638 407.704 614.537 407.704Z",
    fill: "#37474F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M602.606 432.859C602.49 432.858 602.375 432.832 602.269 432.783C602.163 432.734 602.069 432.664 601.992 432.576C596.423 426.091 592.648 418.261 591.043 409.864C591.026 409.756 591.031 409.646 591.057 409.54C591.083 409.434 591.13 409.334 591.195 409.246C591.26 409.158 591.341 409.084 591.435 409.027C591.529 408.971 591.632 408.934 591.741 408.917C591.849 408.901 591.959 408.906 592.065 408.932C592.171 408.958 592.271 409.005 592.359 409.07C592.447 409.135 592.521 409.216 592.578 409.31C592.634 409.403 592.671 409.507 592.688 409.615C594.276 417.681 597.909 425.204 603.238 431.463C603.342 431.586 603.409 431.735 603.431 431.894C603.453 432.053 603.43 432.215 603.364 432.361C603.298 432.507 603.191 432.632 603.057 432.72C602.923 432.808 602.767 432.856 602.606 432.859Z",
    fill: "#37474F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M176.812 209.56V466.719L440.018 314.763L440.002 80.9803L244.3 193.976L237.537 174.487L176.812 209.56Z",
    fill: "url(#paint4_linear_2092_26474)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M176.812 209.56V466.719L440.018 314.763L440.002 80.9803L244.3 193.976L237.537 174.487L176.812 209.56Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M176.812 466.719L190.303 232.936L453.509 80.9803L440.018 314.763L176.812 466.719Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M176.812 466.719L197.048 236.841L460.255 84.8683L440.018 314.763L176.812 466.719Z",
    fill: "url(#paint5_linear_2092_26474)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M176.812 466.719L197.048 236.841L460.255 84.8683L440.018 314.763L176.812 466.719Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M217.3 232.937V490.112L480.507 338.14V104.357L284.788 217.352L278.042 197.863L217.3 232.937Z",
    fill: "url(#paint6_linear_2092_26474)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M217.3 232.937V490.112L480.507 338.14V104.357L284.788 217.352L278.042 197.863L217.3 232.937Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M217.3 490.112L230.791 256.313L493.998 104.357L480.507 338.14L217.3 490.112Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M217.3 490.112L237.536 260.217L500.743 108.245L480.507 338.139L217.3 490.112Z",
    fill: "url(#paint7_linear_2092_26474)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M217.3 490.112L237.536 260.217L500.743 108.245L480.507 338.139L217.3 490.112Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M439.952 571.939C392.7 544.658 348.871 515.001 328.867 480.21L389.676 445.104L439.952 571.939Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M264.535 260.218V517.377L527.742 365.421V131.638L332.023 244.633L325.278 225.144L264.535 260.218Z",
    fill: "url(#paint8_linear_2092_26474)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.535 260.218V517.377L527.742 365.421V131.638L332.023 244.633L325.278 225.144L264.535 260.218Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M340.365 336.245C339.7 336.245 339.601 335.481 339.601 335.033V115.721C339.654 114.87 339.904 114.044 340.33 113.306C340.757 112.568 341.349 111.939 342.06 111.468L532.03 1.81222C532.29 1.64996 532.587 1.55832 532.894 1.54639C533.558 1.54639 533.658 2.31066 533.658 2.75925V222.071C533.606 222.924 533.357 223.754 532.93 224.494C532.503 225.235 531.911 225.867 531.199 226.34L341.229 335.996C340.966 336.15 340.669 336.236 340.365 336.245Z",
    fill: "#37474F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M532.793 2.31087C532.806 2.43234 532.806 2.55492 532.793 2.67639V221.988C532.738 222.695 532.526 223.381 532.173 223.996C531.819 224.611 531.333 225.14 530.749 225.543L340.779 335.199L340.447 335.348C340.424 335.228 340.424 335.104 340.447 334.983V115.672C340.504 114.967 340.717 114.284 341.07 113.672C341.424 113.06 341.909 112.534 342.49 112.133L532.46 2.47701C532.565 2.40372 532.684 2.35282 532.809 2.32749M532.909 0.666037C532.456 0.679507 532.015 0.811261 531.63 1.04818L341.659 110.704C340.824 111.252 340.129 111.989 339.63 112.855C339.131 113.72 338.842 114.691 338.785 115.688V334.999C338.785 336.295 339.433 337.043 340.447 337.043C340.899 337.031 341.341 336.899 341.726 336.661L531.696 227.005C532.535 226.461 533.233 225.725 533.732 224.858C534.232 223.992 534.519 223.02 534.57 222.021V2.70962C534.57 1.41369 533.922 0.649422 532.909 0.666037Z",
    fill: "url(#paint9_linear_2092_26474)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M532.793 2.31087C532.806 2.43234 532.806 2.55492 532.793 2.67639V221.988C532.738 222.695 532.526 223.381 532.173 223.996C531.819 224.611 531.333 225.14 530.749 225.543L340.779 335.199L340.447 335.348C340.424 335.228 340.424 335.104 340.447 334.983V115.672C340.504 114.967 340.717 114.284 341.07 113.672C341.424 113.06 341.909 112.534 342.49 112.133L532.46 2.47701C532.565 2.40372 532.684 2.35282 532.809 2.32749M532.909 0.666037C532.456 0.679507 532.015 0.811261 531.63 1.04818L341.659 110.704C340.824 111.252 340.129 111.989 339.63 112.855C339.131 113.72 338.842 114.691 338.785 115.688V334.999C338.785 336.295 339.433 337.043 340.447 337.043C340.899 337.031 341.341 336.899 341.726 336.661L531.696 227.005C532.535 226.461 533.233 225.725 533.732 224.858C534.232 223.992 534.519 223.02 534.57 222.021V2.70962C534.57 1.41369 533.922 0.649422 532.909 0.666037Z",
    fill: "#37474F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M359.021 124.045L426.51 85.0842V163.006L359.021 201.967V124.045Z",
    fill: "url(#paint10_linear_2092_26474)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M359.021 124.045L426.51 85.0842V163.006L359.021 201.967V124.045Z",
    fill: "#37474F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M416.392 104.507V127.933L414.266 129.113V121.952C414.266 117.998 411.059 116.652 407.071 118.945L378.478 135.476C374.507 137.769 371.284 142.836 371.284 146.79V153.951L369.174 155.214V131.837L416.392 104.507Z",
    fill: "#37474F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M403.399 164.152C399.943 166.146 397.136 164.053 397.136 159.451V121.952L388.446 126.67V164.468C388.446 169.054 385.638 174.437 382.183 176.381L375.902 180.003V182.495L409.646 163.006V160.531L403.399 164.152Z",
    fill: "#37474F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M439.951 81.2462C439.951 83.4061 441.895 84.0208 444.271 82.6584L509.931 44.6943C511.096 44.034 512.093 43.1128 512.842 42.0031C513.592 40.8933 514.074 39.6251 514.251 38.2977C514.251 36.1545 512.307 35.5231 509.931 36.9021L444.321 74.7831C443.137 75.4422 442.124 76.3706 441.365 77.4934C440.606 78.6161 440.122 79.9017 439.951 81.2462Z",
    fill: "#455A64"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M439.951 104.507C439.951 106.666 441.895 107.298 444.271 105.919L509.882 68.0378C511.047 67.3775 512.043 66.4563 512.792 65.3466C513.542 64.2368 514.024 62.9686 514.201 61.6412C514.201 59.498 512.257 58.8666 509.882 60.2456L444.271 98.1267C443.108 98.7853 442.113 99.7039 441.364 100.811C440.614 101.917 440.131 103.182 439.951 104.507Z",
    fill: "#455A64"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M439.951 127.933C439.951 130.093 441.895 130.724 444.271 129.345L509.882 91.4642C511.045 90.8055 512.039 89.8869 512.789 88.7802C513.538 87.6735 514.022 86.4086 514.201 85.0842C514.201 82.9243 512.257 82.293 509.882 83.672L444.271 121.553C443.108 122.212 442.113 123.13 441.364 124.237C440.614 125.344 440.131 126.609 439.951 127.933Z",
    fill: "#455A64"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M439.951 151.31C439.951 153.47 441.895 154.101 444.271 152.722L509.882 114.841C511.045 114.182 512.039 113.264 512.789 112.157C513.538 111.05 514.022 109.785 514.201 108.461C514.201 106.301 512.257 105.67 509.882 107.049L444.271 144.93C443.108 145.588 442.113 146.507 441.364 147.614C440.614 148.72 440.131 149.985 439.951 151.31Z",
    fill: "#455A64"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M359.021 221.456C359.021 223.616 360.949 224.247 363.341 222.868L509.931 138.134C511.096 137.478 512.092 136.56 512.841 135.453C513.591 134.345 514.073 133.079 514.251 131.754C514.251 129.594 512.307 128.98 509.931 130.342L363.341 215.076C362.176 215.732 361.179 216.649 360.429 217.757C359.679 218.864 359.198 220.13 359.021 221.456Z",
    fill: "#455A64"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M359.021 244.832C359.021 246.992 360.949 247.624 363.341 246.245L509.931 161.61C511.096 160.95 512.092 160.029 512.842 158.919C513.591 157.809 514.073 156.541 514.251 155.214C514.251 153.071 512.307 152.439 509.931 153.818L363.341 238.452C362.176 239.108 361.179 240.026 360.429 241.133C359.679 242.24 359.198 243.507 359.021 244.832Z",
    fill: "#455A64"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M359.021 268.226C359.021 270.369 360.949 271 363.341 269.621L509.931 184.987C511.096 184.327 512.092 183.406 512.842 182.296C513.591 181.186 514.073 179.918 514.251 178.591C514.251 176.447 512.307 175.816 509.931 177.195L363.341 261.829C362.174 262.486 361.176 263.407 360.426 264.517C359.676 265.627 359.195 266.897 359.021 268.226Z",
    fill: "#455A64"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M264.535 517.377L311.77 310.875L574.977 158.902L527.742 365.42L264.535 517.377Z",
    fill: "url(#paint11_linear_2092_26474)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M328.934 327.041V480.21L389.676 445.137V291.984L328.934 327.041Z",
    fill: "url(#paint12_linear_2092_26474)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M328.934 327.041V480.21L389.676 445.137V291.984L328.934 327.041Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M440.068 570.942C434.901 567.087 385.09 529.023 359.77 474.578C332.821 416.693 332.854 349.172 332.854 323.768V322.97L513.421 218.731C513.421 244.367 513.421 311.988 540.486 370.073C565.225 423.239 613.124 460.821 620.717 466.57L440.068 570.942Z",
    fill: "#37474F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M512.589 220.227C512.589 246.943 513.104 313.268 539.738 370.488C563.646 421.827 609.103 458.744 619.221 466.536L440.117 569.945C433.122 564.678 385.189 527.246 360.534 474.295C333.618 416.577 333.618 349.188 333.618 323.818V323.502L512.523 220.21M514.184 217.336L331.957 322.555C331.957 346.463 331.458 415.929 358.955 474.993C386.02 532.961 439.951 571.939 439.951 571.939L622.228 466.702C622.228 466.702 568.231 427.725 541.249 369.757C513.736 310.692 514.251 241.227 514.251 217.319L514.184 217.336Z",
    fill: "url(#paint13_linear_2092_26474)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M512.589 220.227C512.589 246.943 513.104 313.268 539.738 370.488C563.646 421.827 609.103 458.744 619.221 466.536L440.117 569.945C433.122 564.678 385.189 527.246 360.534 474.295C333.618 416.577 333.618 349.188 333.618 323.818V323.502L512.523 220.21M514.184 217.336L331.957 322.555C331.957 346.463 331.458 415.929 358.955 474.993C386.02 532.961 439.951 571.939 439.951 571.939L622.228 466.702C622.228 466.702 568.231 427.725 541.249 369.757C513.736 310.692 514.251 241.227 514.251 217.319L514.184 217.336Z",
    fill: "#37474F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M493.633 252.625L436.014 285.854C434.861 286.489 433.878 287.393 433.149 288.489C432.42 289.585 431.966 290.841 431.827 292.151C431.91 294.261 433.921 294.859 436.296 293.48L493.932 260.251C495.072 259.622 496.045 258.73 496.77 257.649C497.495 256.568 497.952 255.33 498.102 254.037C498.003 251.844 496.026 251.246 493.633 252.625Z",
    fill: "#455A64"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M494.861 275.304L437.242 308.532C436.103 309.145 435.137 310.036 434.434 311.123C433.731 312.209 433.314 313.456 433.222 314.746C433.404 316.79 435.498 317.338 437.874 315.959L495.509 282.73C496.643 282.12 497.603 281.231 498.298 280.146C498.993 279.062 499.4 277.818 499.48 276.533C499.314 274.473 497.254 273.974 494.861 275.304Z",
    fill: "#455A64"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M497.171 297.351L439.535 330.58C437.159 331.959 435.431 334.7 435.714 336.678C435.996 338.655 438.173 339.17 440.565 337.791L498.201 304.562C500.577 303.183 502.271 300.458 501.972 298.481C501.673 296.504 499.547 295.972 497.171 297.351Z",
    fill: "#455A64"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M500.628 318.734L442.992 351.963C440.616 353.342 438.971 356.033 439.37 357.96C439.769 359.888 442.028 360.32 444.355 358.941L501.974 325.712C504.366 324.333 505.961 321.658 505.562 319.73C505.164 317.803 503.087 317.355 500.628 318.734Z",
    fill: "#455A64"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M505.313 339.402L447.677 372.631C445.302 374.01 443.756 376.635 444.355 378.48C444.953 380.324 447.229 380.739 449.605 379.36L507.24 346.131C509.633 344.752 511.128 342.144 510.563 340.283C509.998 338.422 507.689 338.023 505.313 339.402Z",
    fill: "#455A64"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M511.394 359.323L370.935 440.418C368.559 441.797 367.114 444.356 367.761 446.134C368.409 447.912 370.885 448.244 373.261 446.865L513.72 365.769C516.112 364.39 517.491 361.848 516.843 360.054C516.195 358.26 513.687 357.944 511.394 359.323Z",
    fill: "#455A64"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M518.787 378.347L378.345 459.442C375.953 460.821 374.64 463.313 375.438 465.008C376.235 466.702 378.761 466.968 381.186 465.589L521.645 384.494C524.038 383.115 525.317 380.623 524.519 378.928C523.722 377.233 521.18 376.984 518.787 378.347Z",
    fill: "#455A64"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M528.008 396.473L387.549 477.568C385.156 478.947 383.977 481.373 384.924 482.985C385.871 484.596 388.579 484.763 390.972 483.384L531.331 402.288C533.707 400.926 534.853 398.517 533.906 396.905C532.959 395.293 530.334 395.094 528.008 396.473Z",
    fill: "#455A64"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M538.758 413.619L398.316 494.698C395.923 496.077 394.86 498.453 395.94 499.964C397.02 501.476 399.861 501.626 402.253 500.23L542.696 419.135C545.088 417.756 546.118 415.413 545.038 413.885C543.958 412.356 541.15 412.24 538.758 413.619Z",
    fill: "#455A64"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M551.019 429.918L410.56 510.997C408.184 512.376 407.237 514.685 408.433 516.131C409.63 517.576 412.57 517.642 414.963 516.263L555.422 435.135C557.798 433.756 558.745 431.48 557.515 430.034C556.286 428.589 553.412 428.489 551.019 429.918Z",
    fill: "#455A64"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M564.559 445.436L424.15 526.515C421.758 527.894 420.827 530.153 422.223 531.499C423.619 532.845 426.576 532.878 428.952 531.499L569.411 450.404C571.803 449.025 572.634 446.798 571.305 445.419C569.976 444.04 566.985 444.074 564.559 445.436Z",
    fill: "#455A64"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M579.512 460.273L439.053 541.351C436.677 542.73 435.896 544.94 437.392 546.253C438.887 547.565 441.944 547.515 444.337 546.136L584.679 465.041C587.055 463.662 587.803 461.502 586.341 460.173C584.879 458.844 581.838 458.894 579.512 460.273Z",
    fill: "#455A64"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M415.129 297.966L348.87 336.179C349.601 360.187 352.343 394.812 362.378 429.686L428.653 391.472C418.601 356.598 415.86 321.957 415.129 297.966Z",
    fill: "url(#paint14_linear_2092_26474)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M415.129 297.966L348.87 336.179C349.601 360.187 352.343 394.812 362.378 429.686L428.653 391.472C418.601 356.598 415.86 321.957 415.129 297.966Z",
    fill: "#37474F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M375.885 330.896C375.975 329.346 375.734 327.795 375.178 326.345C374.622 324.896 373.765 323.581 372.662 322.489L348.87 336.212C349.069 342.559 349.402 349.653 349.983 357.296C353.078 357.652 356.209 357.073 358.972 355.635C368.326 351.348 375.885 340.233 375.885 330.896Z",
    fill: "url(#paint15_linear_2092_26474)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M375.885 330.896C375.975 329.346 375.734 327.795 375.178 326.345C374.622 324.896 373.765 323.581 372.662 322.489L348.87 336.212C349.069 342.559 349.402 349.653 349.983 357.296C353.078 357.652 356.209 357.073 358.972 355.635C368.326 351.348 375.885 340.233 375.885 330.896Z",
    fill: "#37474F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M423.02 368.544C418.601 362.978 409.612 345.782 405.774 338.289C405.624 337.993 405.387 337.749 405.096 337.588C404.805 337.428 404.473 337.358 404.142 337.389C403.811 337.419 403.497 337.548 403.24 337.759C402.983 337.97 402.795 338.253 402.701 338.572C398.549 352.764 396.139 367.41 395.523 382.185C389.99 377.792 385.233 372.501 381.451 366.534C381.29 366.303 381.066 366.122 380.805 366.014C380.545 365.906 380.259 365.874 379.982 365.923C379.704 365.972 379.446 366.099 379.238 366.29C379.031 366.481 378.882 366.727 378.809 366.999C371.565 394.895 375.204 422.342 375.204 422.342L428.653 391.472C426.426 383.763 424.582 376.087 423.02 368.544Z",
    fill: "url(#paint16_linear_2092_26474)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M423.02 368.544C418.601 362.978 409.612 345.782 405.774 338.289C405.624 337.993 405.387 337.749 405.096 337.588C404.805 337.428 404.473 337.358 404.142 337.389C403.811 337.419 403.497 337.548 403.24 337.759C402.983 337.97 402.795 338.253 402.701 338.572C398.549 352.764 396.139 367.41 395.523 382.185C389.99 377.792 385.233 372.501 381.451 366.534C381.29 366.303 381.066 366.122 380.805 366.014C380.545 365.906 380.259 365.874 379.982 365.923C379.704 365.972 379.446 366.099 379.238 366.29C379.031 366.481 378.882 366.727 378.809 366.999C371.565 394.895 375.204 422.342 375.204 422.342L428.653 391.472C426.426 383.763 424.582 376.087 423.02 368.544Z",
    fill: "#37474F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2092_26474",
    x1: 152.6,
    y1: 362.586,
    x2: 211.316,
    y2: 388.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2092_26474",
    x1: 136.12,
    y1: 397.18,
    x2: 197.418,
    y2: 448.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2092_26474",
    x1: 560.53,
    y1: 332.643,
    x2: 624.392,
    y2: 357.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2092_26474",
    x1: 602.085,
    y1: 348.021,
    x2: 689.036,
    y2: 401.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2092_26474",
    x1: 243.465,
    y1: 30.2013,
    x2: 565.335,
    y2: 217.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2092_26474",
    x1: 248.59,
    y1: 34.601,
    x2: 579.821,
    y2: 244.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2092_26474",
    x1: 283.953,
    y1: 53.5758,
    x2: 605.831,
    y2: 241.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2092_26474",
    x1: 289.078,
    y1: 57.9753,
    x2: 620.318,
    y2: 267.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2092_26474",
    x1: 331.189,
    y1: 80.859,
    x2: 653.059,
    y2: 268.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2092_26474",
    x1: 388.365,
    y1: -43.6153,
    x2: 645.526,
    y2: 84.1278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2092_26474",
    x1: 376.112,
    y1: 69.6976,
    x2: 465.036,
    y2: 113.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2092_26474",
    x1: 343.15,
    y1: 111.712,
    x2: 671.928,
    y2: 354.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2092_26474",
    x1: 344.316,
    y1: 267.206,
    x2: 436.774,
    y2: 292.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2092_26474",
    x1: 405.464,
    y1: 170.636,
    x2: 724.912,
    y2: 393.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2092_26474",
    x1: 369.074,
    y1: 280.626,
    x2: 472.175,
    y2: 333.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2092_26474",
    x1: 355.716,
    y1: 317.893,
    x2: 386.528,
    y2: 338.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2092_26474",
    x1: 388.057,
    y1: 326.197,
    x2: 456.631,
    y2: 363.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/Image 3.63ba2b8d698ca5ae35cfc7d532398a42.svg";
export { ForwardRef as ReactComponent };